import BaseModel from './BaseModel';

class Customer extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.setApiDetailsData(data)
  }

  setApiDetailsData = (data) => {
    this.customer_id = data.cus_nomenclature_id;
    this.name = data.name ;
    this.wallet_balance = data.wallet_balance;
    this.mobile_number = data.login_mobile_number;
    this.initial_offer = data.initial_offer;
    this.current_offer = data.current_offer;

    this.onboarding_date_time = data.onboarding_date_time ;
    if(data.platfrom_partner_id && data.platfrom_partner_rmn && data.platform_partner_name) {
      this.platfrom_partner = `${data.platfrom_partner_id} | ${data.platfrom_partner_rmn} | ${data.platform_partner_name}`;
    }
    this.number_of_batteries = data.number_of_batteries;
    if(data.number_of_batteries > 1 && data.current_batteries) {
      this.batteries = data.current_batteries;
    } else {
      this.battery = data.current_batteries;
    }
    this.offer_discounts = data.offer_discounts
    this.status = data.status;
    if(data.address) {
      this.address = `${data.address.address} ${data.address.city} ${data.address.state}`;
      this.pincode = data.address.pincode_code
    }
    if(data.charging_verifications) {
      this.charging_verifications = data.charging_verifications
    }
    if(data.fleet_owner) {
      this.fleet_owner = `${data.fleet_owner.id} - ${data.fleet_owner.firm}`
    }
    if(data.vehicles && data.vehicles.length > 0){
      this.vehicles = data.vehicles;
    }
    this.platfrom_partner_RMN = data.platfrom_partner_rmn;
    this.branch = data.branch_name
  }
}

export default Customer;

